import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 4px;
  flex: 1;
  padding: 0.5rem;
  height: min-content;

  @media (max-width: 630px) {
    padding: 0.25rem;
  }
`;

interface QuestionProps {
  children: React.ReactNode;
}

export function Question({ children }: QuestionProps) {
  return <StyledDiv>{children}</StyledDiv>;
}
